/**
 * @module checkLogin
 */
const auth0 = require('auth0-js');
const Cookies = require('js-cookie');
const { encodeSVG } = require('../svg');

/**
 * Note: Due to setting up our utils with modules.exports and using require,
 * as alternative to inline export on functions and use of import, SVG files are
 * no longer compiled automatically, and as they cannot be set using require,
 * they are hard-coded inline as a failsafe.
 */
const user = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9998 24C5.37289 24 0 18.6271 0 11.9998C0 5.37339 5.37289 0 11.9998 0C18.6271 0 23.9995 5.37339 23.9995 11.9998C23.9995 18.6271 18.6266 24 11.9998 24ZM11.9994 22.5001C14.3134 22.5001 16.4339 21.7281 18.1693 20.4596C17.8638 19.9416 17.3118 19.1176 16.4689 18.2746C15.8454 17.6512 15.0874 17.0262 14.4144 16.5057C13.6884 16.9657 12.8754 17.2512 11.9994 17.2512C11.1235 17.2512 10.311 16.9657 9.585 16.5057C8.91201 17.0262 8.15403 17.6512 7.53054 18.2746C6.68756 19.1181 6.13557 19.9416 5.83008 20.4596C7.56504 21.7281 9.685 22.5001 11.9994 22.5001ZM15.7498 10.8768C15.7498 8.18337 14.0709 6.00092 11.9999 6.00092C9.92897 6.00092 8.25 8.18337 8.25 10.8768C8.25 13.5688 9.92897 15.7507 11.9999 15.7507C14.0709 15.7507 15.7498 13.5688 15.7498 10.8768ZM11.9998 1.5C6.2009 1.5 1.5 6.2014 1.5 11.9998C1.5 14.9657 2.73947 17.6317 4.71643 19.5411C4.99143 19.0486 5.53842 18.1887 6.4304 17.2962C7.04139 16.6852 7.78287 16.0692 8.45036 15.5472C7.41088 14.3822 6.74989 12.7288 6.74989 10.8768C6.74989 7.35488 9.10034 4.50094 11.9998 4.50094C14.8992 4.50094 17.2497 7.35488 17.2497 10.8768C17.2497 12.7288 16.5882 14.3822 15.5492 15.5472C16.2167 16.0692 16.9582 16.6852 17.5692 17.2962C18.4616 18.1887 19.0081 19.0486 19.2836 19.5411C21.2601 17.6317 22.5001 14.9652 22.5001 11.9998C22.4996 6.2014 17.7987 1.5 11.9998 1.5Z" fill="#444"/>
</svg>`;
const defaultBusinessAvatar = `
<svg width="100%" height="100%" viewBox="0 0 500 500" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g id="Layer1">
        <circle cx="250" cy="250" r="250" style="fill:rgb(246,246,246);"/>
        <path d="M250,0C387.979,0 500,112.021 500,250C500,387.979 387.979,500 250,500C112.021,500 0,387.979 0,250C0,112.021 112.021,0 250,0ZM250,31C370.869,31 469,129.131 469,250C469,370.869 370.869,469 250,469C129.131,469 31,370.869 31,250C31,129.131 129.131,31 250,31Z" style="fill:rgb(159,159,160);"/>
    </g>
    <g transform="matrix(0.667924,0,0,0.667924,100.385,96.0116)">
        <g id="Layer2">
            <path d="M128,148L128,108C128,101.4 133.4,96 140,96L180,96C186.6,96 192,101.4 192,108L192,148C192,154.6 186.6,160 180,160L140,160C133.4,160 128,154.6 128,148ZM268,160L308,160C314.6,160 320,154.6 320,148L320,108C320,101.4 314.6,96 308,96L268,96C261.4,96 256,101.4 256,108L256,148C256,154.6 261.4,160 268,160ZM140,256L180,256C186.6,256 192,250.6 192,244L192,204C192,197.4 186.6,192 180,192L140,192C133.4,192 128,197.4 128,204L128,244C128,250.6 133.4,256 140,256ZM268,256L308,256C314.6,256 320,250.6 320,244L320,204C320,197.4 314.6,192 308,192L268,192C261.4,192 256,197.4 256,204L256,244C256,250.6 261.4,256 268,256ZM192,340L192,300C192,293.4 186.6,288 180,288L140,288C133.4,288 128,293.4 128,300L128,340C128,346.6 133.4,352 140,352L180,352C186.6,352 192,346.6 192,340ZM268,352L308,352C314.6,352 320,346.6 320,340L320,300C320,293.4 314.6,288 308,288L268,288C261.4,288 256,293.4 256,300L256,340C256,346.6 261.4,352 268,352ZM459.845,463.958L448,512C303.598,608.38 154.311,609.278 0,512L-12.764,463.909L31.5,464L31.5,24C31.5,10.7 42.2,0 55.5,0L392.5,0C405.8,0 416.5,10.7 416.5,24L416.5,464L459.845,463.958ZM79.5,463L192,463L192,396C192,389.4 197.4,384 204,384L244,384C250.6,384 256,389.4 256,396L256,463L368.5,463L368.5,49L80,48L79.5,463Z" style="fill:rgb(159,159,160);fill-rule:nonzero;"/>
        </g>
    </g>
</svg>`;

/**
 * Convenience function to check for the `expires_at` cookie and determine authentication status based on its value.
 *
 * @returns {boolean} Boolean flag indicating whether or not the user is authenticated.
 */
const isAuthenticated = () => {
  const expiresAt = Number(Cookies.get('expires_at')) * 1000;
  return Number(new Date().getTime()) < Number(expiresAt);
};

/**
 * Convenience function to determine whether the specified user is an individual or organization.
 *
 * @param {object} userProfileInfo - User profile data object.
 *
 * @returns {boolean} Boolean flag indicating whether or not the specified profile is an organization.
 */
const isOrganizationProfile = (userProfileInfo) => {
  return Boolean(
    userProfileInfo &&
      userProfileInfo['https://www.life.church/user_metadata'].organizationType,
  );
};

/**
 * Convenience function to check the login status for a user and set/unset browser storage and UI elements status as needed.
 */
/* istanbul ignore next */
const checkLogin = () => {
  const localStorageProfile =
    window.localStorage.getItem('user_profile') || null;
  const userProfile = localStorageProfile
    ? JSON.parse(localStorageProfile)
    : null;
  const loginWrapper = document.querySelector('#login-wrapper');
  const loginHyperlink = document.querySelector('#user-login');
  const loginStatus = document.querySelector('#user-login .login-text');
  const userAvatar = document.querySelector('#user-login .avatar');

  // Segment integration and identify triggering, when available.
  if (userProfile) {
    const segmentUser = {};
    const userAnalyticsKeys = [
      'sub',
      'locale',
      'nickname',
      'https://www.life.church/rock_person_alias_id',
    ];
    userAnalyticsKeys.forEach((key) => {
      if (userProfile[key]) {
        switch (key) {
          case 'sub':
            segmentUser.auth0_id = userProfile[key];
            break;
          case 'nickname':
            segmentUser.webnickname = userProfile[key];
            break;
          case 'https://www.life.church/rock_person_alias_id':
            segmentUser.userId = userProfile[key];
            break;
          case 'locale':
            segmentUser.language = userProfile[key];
            break;
          default:
            break;
        }
      }
    });

    if (window.analytics && window.analytics.identify) {
      window.analytics.identify(
        userProfile['https://www.life.church/rock_person_alias_id'],
        segmentUser,
      );
    }
  }

  /**
   * Auth0 initialization.
   */
  const webAuth = new auth0.WebAuth({
    audience: process.env.AUTHAUDIENCE,
    clientID: process.env.AUTHCLIENTID,
    domain: process.env.AUTHDOMAIN,
    responseType: 'token id_token',
    scope: 'openid profile',
  });

  /**
   * Convenience function to remove the local storage item for user_profile and reset the login wrapper class.
   */
  function destroyUserSession() {
    window.localStorage.removeItem('user_profile');
    if (loginWrapper) {
      loginWrapper.classList.remove('logged-in');
    }
  }

  /**
   * Convenience function to condense the specified name to first and last name, not taking into account middle/third names.
   *
   * @param {string} name - The user's name.
   *
   * @returns {string} The condensed name value.
   */
  function condensedName(name) {
    if (name.length > 0) {
      return `${name.substring(0, name.indexOf(' ') + 2)}.`;
    }
    return '';
  }

  /**
   * Convenience function to display the user's first name and last initial if
   * the following conditions are met:
   *
   * 1. The user must not have an email address in app_meta given_name and
   * must have something in user_meta first_name.
   * 2. The user does have a first name last name in user_metadata.
   * 3. The user has something in app_metadata.given_name.
   *
   * @param {object} profile - The user profile data object.
   *
   * @returns {string} A user's first name and last initial or an empty string.
   */
  function getUserNameFromProfile(profile) {
    try {
      const userMetadata = profile['https://www.life.church/user_metadata'];
      const isOrganization = isOrganizationProfile(profile);
      const isFbUserNameEmpty =
        profile &&
        profile.sub.startsWith('facebook') &&
        profile.given_name &&
        profile.given_name.length === 0;

      if (isOrganization) {
        return userMetadata.last_name;
      }
      if (
        (profile.name.includes('@') && userMetadata.first_name.length === 0) ||
        isFbUserNameEmpty
      ) {
        document
          .querySelector('.login .login-text')
          .classList.add('no-username');
        return '';
      }

      let user_name;
      const isProfileFirstName =
        userMetadata &&
        userMetadata.first_name &&
        userMetadata.first_name.length > 0;
      const isProfileGivenName =
        profile.given_name && profile.given_name.length > 0;

      switch (true) {
        case isProfileFirstName:
          user_name = `${userMetadata.first_name} ${
            userMetadata.last_name ?? ''
          }`;
          return condensedName(user_name);
        case isProfileGivenName:
          user_name = `${profile.given_name} ${profile.family_name ?? ''}`;
          return condensedName(user_name);
        default:
          return '';
      }
    } catch (e) {
      return '';
    }
  }

  /**
   * Convenience function to disable the login hyperlink when the user is logged in.
   */
  function disableHyperlink() {
    if (loginHyperlink) {
      loginHyperlink.setAttribute('onclick', 'return false');
    }
  }

  /**
   * Convenience function to display the user profile, setting the profile src and innerHTML as needed.
   *
   * @param {object} profile - The user profile data object.
   */
  function displayProfile(profile) {
    const isOrganization = isOrganizationProfile(profile);

    const avatar =
      profile.picture ||
      (isOrganization
        ? `data:image/svg+xml,${encodeSVG(defaultBusinessAvatar)}`
        : `${process.env.IMGIX_BASE_URL}/lc-site/avatars/defaultAvatar.svg`);

    if (userAvatar) {
      userAvatar.setAttribute('src', avatar);
    }

    if (loginStatus) {
      loginStatus.innerHTML = getUserNameFromProfile(profile);
    }
    disableHyperlink();
  }

  /**
   * Convenience function to fetch the user profile and trigger displayProfile.
   * If there is a userProfile object, the profile is set to a cached version.
   */
  function getProfile() {
    if (!userProfile) {
      const accessToken = Cookies.get('access_token');

      if (accessToken) {
        webAuth.client.userInfo(accessToken, (err, profile) => {
          if (profile) {
            window.localStorage.setItem(
              'user_profile',
              JSON.stringify(profile),
            );
            displayProfile(profile);
          }
        });
      }
    } else {
      displayProfile(userProfile);
    }
  }

  /**
   * Convenience function to display the login partial based on `isAuthenticated` status.
   * This function sets the class list, user avatar src, and innerHTML of the login status as needed.
   */
  function displayLoginPartial() {
    if (isAuthenticated()) {
      if (loginWrapper) {
        loginWrapper.classList.add('logged-in');
      }
      getProfile();
    } else {
      if (userAvatar) {
        userAvatar.setAttribute('src', `data:image/svg+xml,${encodeSVG(user)}`);
      }
      if (loginStatus) {
        loginStatus.innerHTML = 'Log in';
      }
    }
  }

  if (!isAuthenticated()) {
    destroyUserSession();
  }

  displayLoginPartial();
};

/**
 * Convenience function to log the user out, removing all necessary localStorage items and cookies, and setting the window.location.href to `/logout/`.
 * Note: This removes the data from web giving and all session and cookies are destroyed.
 */
const logout = () => {
  window.localStorage.removeItem('LC:WebGiving:userGivingData');
  window.localStorage.removeItem('access_token');
  window.localStorage.removeItem('auth0-authorize-state');
  window.localStorage.removeItem('expires_at');
  window.localStorage.removeItem('user_profile');

  document.cookie = 'expires_at=; expires=Thu, 01 Jan 1970 00:00:00 UTC';
  document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC';
  document.cookie = 'uid=; expires=Thu, 01 Jan 1970 00:00:00 UTC';

  window.location.href = '/logout/';
};

module.exports = {
  checkLogin,
  isAuthenticated,
  isOrganizationProfile,
  logout,
};
